"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var actionTypes_1 = require("../actionTypes");

exports.authReducer = function (state, action) {
  if (state === void 0) {
    state = {};
  }

  var _a, _b, _c;

  switch (action.type) {
    case actionTypes_1.SIGNIN_USER:
    case actionTypes_1.REFRESH_USER_TOKENS:
      return __assign(__assign({}, state), {
        accessToken: (_a = action.data) === null || _a === void 0 ? void 0 : _a.accessToken,
        refreshToken: (_b = action.data) === null || _b === void 0 ? void 0 : _b.refreshToken,
        expires: (_c = action.data) === null || _c === void 0 ? void 0 : _c.expires
      });

    case actionTypes_1.SET_TENANT:
      return __assign(__assign({}, state), {
        tenantId: action.id
      });

    case actionTypes_1.SET_CLIENT:
      return __assign(__assign({}, state), {
        clientId: action.id
      });

    default:
      return __assign({}, state);
  }
};